import React from "react";

/*
 * Manual horizontal-scroll rail (no auto-rotation anywhere — brief §8.2).
 * The cut-off card is the scroll affordance: ~2.5 cards visible at 375px.
 */

export default function Rail({ gap = 24, className = "", children, ...rest }) {
  return (
    <div
      className={`ic-rail flex overflow-x-auto items-stretch pb-4 ${className}`}
      style={{ gap }}
      {...rest}
    >
      {children}
    </div>
  );
}
